<template lang="html">
  <div>
    <nav class="topbar fixed-top navbar" :class="'topbar-' + profile">
      <v-container>
        <v-link v-if="profile === 'client'" :to="{ name: 'client-dashboard' }"
          ><v-logo white
        /></v-link>
        <v-link v-else :to="{ name: 'vibbrant-dashboard' }"
          ><v-logo white
        /></v-link>

        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
        <v-icon name="menu"/>
      </button> -->

        <div class="collapse navbar-collapse" id="navbar-menu">
          <ul class="navbar-nav ml-auto">
            <!-- CLIENT -->
            <v-dropdown v-if="profile === 'client'" class="nav-item">
              <v-icon class="nav-item-mobile-icon" name="group" />
              <span class="nav-item-label">Profissionais</span>
              <v-icon name="drop-down" />
              <v-button-dropdown
                slot="menu"
                @click="gotoUserList('client-vibbrants-active', 'active')"
              >
                <v-icon name="v-active" /> Ativos
              </v-button-dropdown>
              <v-button-dropdown
                slot="menu"
                @click="gotoUserList('client-vibbrants-pending', 'pending')"
              >
                <v-icon name="v-pending" /> Em contratação
              </v-button-dropdown>
              <v-button-dropdown
                slot="menu"
                @click="gotoUserList('client-vibbrants-finalized', 'finalized')"
              >
                <v-icon name="v-finalized" /> Finalizados
              </v-button-dropdown>
              <v-button-dropdown
                slot="menu"
                @click="
                  gotoUserList(
                    'client-vibbrants-credit-transfer',
                    'credit-transfer'
                  )
                "
              >
                <v-icon name="cash" /> Transferência de Crédito
              </v-button-dropdown>
              <v-button-dropdown slot="menu" @click="searchVibbrantes">
                <v-icon name="v-find" /> Buscar
              </v-button-dropdown>
            </v-dropdown>
            <!-- /CILENT -->
            <!-- VIBBRANTES -->
            <v-dropdown v-else class="nav-item">
              <v-icon class="nav-item-mobile-icon" name="group" />
              <span class="nav-item-label">Clientes</span>
              <v-icon name="drop-down" />
              <v-button-dropdown
                slot="menu"
                @click="gotoUserList('vibbrant-clients-active', 'active')"
              >
                <v-icon name="v-active" /> Ativos
              </v-button-dropdown>
              <v-button-dropdown
                slot="menu"
                @click="gotoUserList('vibbrant-clients-pending', 'pending')"
              >
                <v-icon name="v-pending" /> Pendentes
              </v-button-dropdown>
              <v-button-dropdown
                slot="menu"
                @click="gotoUserList('vibbrant-clients-finalized', 'finalized')"
              >
                <v-icon name="v-finalized" /> Finalizados
              </v-button-dropdown>
            </v-dropdown>
            <!-- /VIBBRANTES -->

            <!-- CARRINHO -->
            <li class="nav-item" v-if="profile === 'client'">
              <v-button :to="{ name: 'client-search-request' }">
                <v-icon name="cart" />
                <v-text
                  tag="span"
                  class="topbar-notification"
                  v-if="totalVibbrantesSelected > 0"
                >
                  {{ totalVibbrantesSelected }}</v-text
                >
              </v-button>
            </li>
            <!-- /CARRINHO -->
          </ul>

          <ul class="navbar-nav --ml-auto">
            <li class="nav-item">
              <span class="navbar-divider"></span>
            </li>

            <li class="nav-item">
              <v-button :to="{ name: profile + '-wallet' }">
                <v-icon name="cash" />
                <span v-if="profile === 'client'" class="nav-item-label">{{
                  clientBalances.total | currency
                }}</span>
                <span v-else class="nav-item-label">{{
                  vibbranteBalances.total | currency
                }}</span>
              </v-button>
            </li>

            <!-- NOTIFICATIONS -->
            <v-dropdown class="nav-item" tag="li" right maxheight="400px">
              <v-icon name="alert" />
              <v-text
                tag="span"
                class="topbar-notification"
                v-if="totalNotification > 0"
              >
                {{ totalNotification }}</v-text
              >
              <!-- <v-icon name="drop-down"/> -->

              <template v-for="notification in notifications">
                <v-button-notification
                  slot="menu"
                  :to="notification"
                  icon="alert"
                  :time="notification.created_at"
                >
                  {{ notification.subject }}
                </v-button-notification>
                <!--<v-button-notification slot="menu" :to="{name:'client-new-choose'}" icon="cash" time="há 1 hora">
                Débito vence em 3 dias
              </v-button-notification>-->
              </template>
            </v-dropdown>
            <!-- /NOTIFICATIONS -->

            <v-dropdown class="nav-item" tag="li" right>
              <v-icon class="nav-item-mobile-icon" name="user" />
              <span class="nav-item-label">{{
                this.$store.state.auth.user.name
              }}</span>
              <v-icon name="drop-down" />
              <v-button-dropdown
                slot="menu"
                :to="{ name: profile + '-wallet' }"
              >
                <v-icon name="cash" /> Carteira
              </v-button-dropdown>
              <v-button-dropdown
                slot="menu"
                :to="{ name: profile + '-profile' }"
              >
                <v-icon name="user" /> Perfil
              </v-button-dropdown>
              <v-button-dropdown slot="menu" @click="logout">
                <v-icon name="exit-to-app" /> Sair
              </v-button-dropdown>
            </v-dropdown>

            <li class="nav-item">
              <span class="navbar-divider"></span>
            </li>

            <li class="nav-item">
              <v-button :to="{ name: 'faq' }" target="_blank">
                <v-icon name="live-help" />
                <v-text tag="span" class="topbar-news"> Novo!</v-text>
                <span class="nav-item-label">FAQs</span>
              </v-button>
            </li>

            <li class="nav-item">
              <span class="navbar-divider"></span>
            </li>

            <v-dropdown class="nav-item" tag="li" right>
              <v-icon name="feedback" />
              <!-- <v-button-dropdown slot="menu" @click="feedback_modal_show = true"><v-icon name="rate-review"/> Avaliar a Plataforma</v-button-dropdown> -->
              <v-button-dropdown
                slot="menu"
                :to="{ name: 'faq' }"
                target="_blank"
                ><v-icon name="live-help" /> FAQs</v-button-dropdown
              >
              <v-button-dropdown
                v-if="profile === 'client'"
                slot="menu"
                :to="{ name: 'accept' }"
                target="_blank"
                ><v-icon name="file" /> Termos de aceite</v-button-dropdown
              >
              <v-button-dropdown
                v-if="profile === 'vibbrant'"
                slot="menu"
                :to="{ name: 'accept-vibbrant-show' }"
                target="_blank"
                ><v-icon name="file" /> Termos de aceite</v-button-dropdown
              >
              <v-button-dropdown
                v-if="profile === 'vibbrant'"
                slot="menu"
                :to="{ name: 'manual' }"
                target="_blank"
                ><v-icon name="file" /> Manual boas práticas</v-button-dropdown
              >
              <!-- v-button-dropdown v-if="profile === 'vibbrant'" slot="menu" :to="{name:'tutorials-vibbrant'}" target="_blank"><v-icon name="file"/> Tutoriais</v-button-dropdown-->
              <v-button-dropdown
                slot="menu"
                :to="{ name: 'terms' }"
                target="_blank"
                ><v-icon name="file" /> Termos de uso</v-button-dropdown
              >
              <v-button-dropdown slot="menu" @click="help_modal_show = true"
                ><v-icon name="phone-in-talk" /> Solicitar
                ajuda</v-button-dropdown
              >
              <!-- <v-button-dropdown slot="menu" @click="bug_modal_show = true"><v-icon name="bug-report"/> Informar um BUG</v-button-dropdown> -->
            </v-dropdown>
          </ul>
        </div>
      </v-container>
    </nav>
    <!-- MODALS -->
    <v-modals
      name="feedback"
      :show="feedback_modal_show"
      :data="{}"
      @onHide="feedback_modal_show = false"
    />
    <v-modals
      name="bug"
      :show="bug_modal_show"
      :data="{}"
      @onHide="bug_modal_show = false"
    />
    <v-help
      name="help"
      :show="help_modal_show"
      :data="{}"
      :profile="profile"
      @onHide="help_modal_show = false"
    />
  </div>
</template>

<script>
import ButtonNotification from './button-notification';
import ButtonDropdown from './button-dropdown';
import HelpModal from '@/parts/modals/help';

export default {
  props: {
    profile: String,
  },
  components: {
    'v-button-notification': ButtonNotification,
    'v-button-dropdown': ButtonDropdown,
    'v-help': HelpModal,
  },
  data() {
    return {
      project_menu_active: false,
      feedback_modal_show: false,
      help_modal_show: false,
      bug_modal_show: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      window.location.href = 'https://www.vibbra.com.br/';
    },
    searchVibbrantes() {
      this.$router.push({ name: 'client-search' });
    },
    gotoUserList(to) {
      this.$router.push({ name: to });
      // setTimeout(() => { jQuery('#user-list-tabs [href="#' + tab + '"]').tab('show') }, 200)
    },
  },
  computed: {
    clientBalances() {
      return this.$store.getters.client_balances;
    },
    vibbranteBalances() {
      return this.$store.getters.vibbrante_balances;
    },
    notifications() {
      if (this.profile === 'client') {
        return this.$store.getters.client_notifications;
      }
      return this.$store.getters.vibbrante_notifications;
    },
    totalNotification() {
      if (this.profile === 'client') {
        return this.$store.getters.client_notifications.length;
      }
      return this.$store.getters.vibbrante_notifications.length;
    },
    totalVibbrantesSelected() {
      return this.$store.getters.selected_vibbrantes.length;
    },
  },
};
</script>

<style lang="scss">
$height: 62px;
.navbar.topbar {
  height: $height;
  padding: 0;
  background-color: #000;
  .container {
    position: relative;
  }
  .navbar-collapse {
    display: flex;
    flex-basis: auto;
    .navbar-nav {
      display: flex;
      flex-direction: row;
    }
  }
  .navbar-nav .dropdown-menu {
    position: absolute;
    right: 0;
    left: auto;
  }

  .nav-item-mobile-icon {
    display: none;
  }

  .logo {
    height: 44px;
  }
  .topbar-notification {
    position: absolute;
    background: red;
    font-size: 12px;
    line-height: 1em;
    text-align: center;
    padding: 4px;
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
    top: 10px;
    right: 4px;
  }
  .topbar-news {
    position: absolute;
    background: yellow;
    font-size: 10px;
    color: #212529;
    line-height: 1em;
    text-align: center;
    padding: 4px;
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
    top: 5px;
    right: 0px;
  }
  .nav-item {
    & > .button {
      height: $height;
      color: rgba(#fff, 0.8) !important;
      border-radius: 0;
      padding: 0;

      &:after {
        background-color: rgba(#fff, 0.4) !important;
      }
      &:hover {
        color: rgba(#fff, 1) !important;
      }
      & > .button-inner {
        padding: 0 15px;
        & > .icon {
          font-size: 1.4em;
        }
        & > .icon.icon-drop-down {
          font-size: 1em;
        }
      }
    }
  }

  .dropdown.nav-item {
    &.show > .button {
      height: $height;
      color: rgba(#fff, 1) !important;

      &:after {
        // transition: 0s;
        // transform: translate(-50%, -50%) scale(1.25,1.25);
        opacity: 0.4;
        // border-radius: 0;
        background-color: rgba(#fff, 0.4) !important;
      }
    }
  }
  .navbar-divider {
    display: block;
    height: 100%;
    width: 1px;
    background: rgba(#fff, 0.3);
    margin: 0;
  }

  @include media-breakpoint-down(md) {
    .nav-item-label {
      display: none;
    }
    .icon-drop-down {
      display: none;
    }
    .nav-item-mobile-icon {
      display: inline-block;
    }
    .nav-item.dropdown {
      position: initial;

      .dropdown {
        max-width: 100%;
        right: 0;
      }
    }
  }
  @include media-breakpoint-down(xs) {
    .nav-item {
      & > .button {
        & > .button-inner {
          padding: 0 6px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/topbar.vue